import { Component, OnInit, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MomMinutesOfMeetingService } from 'src/app/services/mom-minutes-of-meeting.service';

@Component({
  selector: 'app-mom-approve-meeting',
  templateUrl: './mom-approve-meeting.component.html',
  styleUrls: ['./mom-approve-meeting.component.scss']
})
export class MomApproveMeetingComponent implements OnInit {

  meetingList:any
  meetingId:number = 0
  constructor(private dialog: MatDialog, private router: Router, 
    private momMinutesOfMeetingService: MomMinutesOfMeetingService
  ) { }

  ngOnInit() {
    this.getAllMeetings()
  }


  getAllMeetings(){
    this.momMinutesOfMeetingService.getApproverMeetingsByUserId()//getMethod('getApproverMeetingsByUserId')
    .subscribe((res:any)=>{
      this.meetingList = res
      console.log(res)
    })
  }

  openConfirmationDialog(templateRef: TemplateRef<any>, id:number){
    this.meetingId = id
    this.dialog.open(templateRef,{
      width: '35%',
      // height: '15%',
      hasBackdrop: false
    })
  }

  goToRecordMeeting(){
    sessionStorage.setItem('startTime', String(new Date().toISOString()))
    this.router.navigate(['/secure/mom-meeting/start-meeting/record', {mode: 'record', id: this.meetingId}])
    this.dialog.closeAll()
  }

  goToMeetingApproval(id:number){
    this.router.navigate(['/secure/mom-meeting/meeting-approval/approval', {mode: 'approval', id: id}])
  }
}
